import auth from "./auth";

//* para acceder al store
import {allowedBaseSubscriptionPaths, allowedPremiumSubscriptionPaths, checkPermisos} from "./subscription-routes";


export default {

  guest(to, from, next) {
    next(!auth.check());
  },

  //* comprobamos que si está logeado y es de Selfie no le permita entrar a las diferentes rutas.
  auth(to, from, next) {

    if (to.name === 'turnos-operarios-external-link') {
      next(); // Permitir acceso a la ruta externa sin autenticación
      return;
    }

    let vm = this;

    var esSelfi = false;

    const esSelfiCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("esSelfi="));

    // Verificar si la cookie existe antes de intentar acceder a su valor
    if (esSelfiCookie) {
      esSelfi = esSelfiCookie.split("=")[1];
    } else {
      esSelfi = false;
    }

    if (auth.check()) {
      //* urls a las que podran acceder los usuarios de SELFI
      const allowedPaths = [
        "/configuracion-carta",
        "/perfil",
        "/soporte-online",
        "/guia-usuario"
 
      ];

      if (!esSelfi) {
        //* si no es Selfi pasan x delante de todo.

        checkPermisos(to);

        next(true);
      } else if (allowedPaths.includes(to.path)) {
        next(true);
      } else {
        next({
          path: "/configuracion-carta",
        });
      }
    } else {
      next({
        path: "/login",
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/routes/middleware.js